document.addEventListener('DOMContentLoaded', () => {
	if (localStorage.getItem('buyingRate') != null){
		if (localStorage.getItem('buyingRate') == 'Entrega inmediata') {
			$('[data-order-option="Preventa"]').css('display', 'none');
		}else if(localStorage.getItem('buyingRate') == 'Preventa'){
			$('[data-order-option="Entrega inmediata"]').css('display', 'none');
		}
	}else if (localStorage.getItem('buyingRate') == null){
		$('[data-order-option="Preventa"]').css('display', 'block');
		$('[data-order-option="Entrega inmediata"]').css('display', 'block');
	}
});